var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1062 4.66256L7.08125 7.1128C6.57813 7.51909 6.48125 8.25041 6.8625 8.77233C7.26563 9.32864 8.05 9.43802 8.59062 9.01611L11.6938 6.60338C11.9125 6.43461 12.225 6.47211 12.3969 6.69088C12.5688 6.90966 12.5281 7.22219 12.3094 7.39408L11.6562 7.90038L16 11.9008V6.00019H15.9781L15.8562 5.92206L13.5875 4.4688C13.1094 4.16252 12.55 4 11.9812 4C11.3 4 10.6375 4.2344 10.1062 4.66256V4.66256ZM10.8188 8.55044L9.20312 9.80681C8.21875 10.5756 6.79062 10.3756 6.05312 9.36302C5.35937 8.4098 5.53437 7.07842 6.45 6.33772L9.05 4.2344C8.6875 4.08126 8.29688 4.00313 7.9 4.00313C7.3125 4 6.74062 4.17502 6.25 4.50005L4 6.00019V13.0009H4.88125L7.7375 15.6074C8.35 16.1668 9.29687 16.123 9.85625 15.5105C10.0281 15.3198 10.1438 15.0979 10.2031 14.8667L10.7344 15.3542C11.3438 15.9136 12.2937 15.873 12.8531 15.2636C12.9937 15.1104 13.0969 14.9323 13.1625 14.7479C13.7688 15.1542 14.5937 15.0698 15.1031 14.5135C15.6625 13.9041 15.6219 12.954 15.0125 12.3946L10.8188 8.55044V8.55044ZM3 6.00019H0V13.0009C0 13.554 0.446875 14.001 1 14.001H2C2.55313 14.001 3 13.554 3 13.0009V6.00019ZM1.5 13.0009C1.225 13.0009 1 12.7758 1 12.5008C1 12.2258 1.225 12.0008 1.5 12.0008C1.775 12.0008 2 12.2258 2 12.5008C2 12.7758 1.775 13.0009 1.5 13.0009ZM17 6.00019V13.0009C17 13.554 17.4469 14.001 18 14.001H19C19.5531 14.001 20 13.554 20 13.0009V6.00019H17ZM19 12.5008C19 12.7758 18.775 13.0009 18.5 13.0009C18.225 13.0009 18 12.7758 18 12.5008C18 12.2258 18.225 12.0008 18.5 12.0008C18.775 12.0008 19 12.2258 19 12.5008Z",
    fill: "#343AD7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default ForwardRef;